<template>
  <div
    class="orm-mb-16 orm-col-xs-12 orm-col-sm-8 orm-col-md-4 orm-col-lg-3 orm-px-xs-8 orm-carlist"
  >
    <div class="orm-row center-xs">
      <div class="orm-col-xs-12">
        <div class="orm-background--cta2 orm-h100">
          <div class="orm-topseller" v-if="data.is_top">
            <span class="orm-topseller__icon"
              ><i class="fas fa-thumbs-up"></i
            ></span>
            <span class="orm-topseller__icon_text">Top-Seller</span>
          </div>
          <div class="orm-slider__imagecontainer" v-if="images">
            <img v-if="images.length > 0" :src="images[0].image" alt="" />
            <div
              v-else
              :style="{ paddingTop: '56.25%' }"
              style="background-color: #fff;box-shadow: 0 14px 20px #fff;"
            ></div>
          </div>
          <div class="orm-slider__imagecontainer" v-else>
            <div
              :style="{ paddingTop: '56.25%' }"
              style="background-color: #fff;box-shadow: 0 14px 20px #fff;"
            ></div>
          </div>
          <div
            class="orm-abo-content__container orm-py-24 orm-px-8 orm-px-sm-24"
          >
            <h3 class="orm-headline__h3 orm-headline__h3--list orm-mb-0">
              {{ stripHTML(data["vehicle_name"]) }}
            </h3>
            <h4 class="orm-headline__h4">
              {{ stripHTML(data.vehicle_group.text_web) }}
            </h4>

            <div class="orm-row">
              <span class="orm-col-xs-12 orm-mb-8" v-if="data.fuel_type"
                ><i class="fas fa-long-arrow-right orm-mr-4"></i>
                {{ data.fuel_type }}
              </span>
              <span
                class="orm-col-xs-12 orm-mb-8"
                v-if="data?.features?.find((item) => item.id === 'AT')"
              >
                <i class="orm_icon_automatik orm-mr-4"></i
                >{{
                  data?.features?.find((item) => item.id === "AT").description
                }}
              </span>
              <span
                class="orm-col-xs-12 orm-mb-8"
                v-if="data?.features?.find((item) => item.id === 'MAN')"
              >
                <i class="orm_icon_gear orm-mr-4"></i>
                {{
                  data?.features?.find((item) => item.id === "MAN").description
                }}
              </span>
              <span class="orm-col-xs-12"
                ><i class="fal fa-leaf orm-mr-4"></i>
                {{ data?.wltp.co2_emissions }} g/km |
                {{ data?.wltp.efficiency_class }}</span
              >
            </div>
            <p class="orm-price__txt" v-if="data.prices && abolength">
              ab
              <span style="white-space: nowrap; font-size: 22px">
                {{
                  convertCurrency(
                    showNettoPrice
                      ? data.prices?.sort((a, b) =>
                          a.price > b.price ? 1 : -1
                        )[0].price
                      : data.prices?.sort((a, b) =>
                          a.price_with_tax > b.price_with_tax ? 1 : -1
                        )[0].price_with_tax
                  )
                }}
              </span>
              / Monat
            </p>
            <button
              class="orm-button__cta outline wide orm-w100"
              @click="getCars(car)"
            >
              {{ i18n("topcar/select") || "Der passt zu mir" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import store from "@/store";
import { convertCurrency, formateDate } from "@/constants/formater";
import { routeToSteps } from "@/constants/getRoutes";

// import Slider from "@/components/ui/image-slider.vue";

import i18n from "@/mixins/mixins";
import stripHTML from "@/mixins/mixins";

export default defineComponent({
  name: "TopCar",
  components: {
    // Slider,
  },
  emits: ["openSearchTarif"],
  mixins: [i18n, stripHTML],
  data() {
    return {
      car: Object,
      images: null,
      showSearch: false,
      station: store.getters["userSession/GET_STATION"],
      selectedStation: null,
      env: process.env,
      abolength: null,
      showNettoPrice: false,
    };
  },
  props: {
    data: Object,
  },
  setup() {
    return {
      convertCurrency,
      formateDate,
      routeToSteps,
    };
  },
  async mounted() {
    const showNetto = await store.getters["ORMgeneral/GET_PARAMETER"](
      "BORM_SHOW_NETTO_PRICE"
    );

    switch (showNetto) {
      case "1":
        this.showNettoPrice = true;
        break;
      default:
        break;
    }
    this.car = await this.data.vehicle_group;

    //{ image: this.data.images.interior[0].url }
    const images = [];
    this.data.images.exterior.forEach((element) => {
      images.push({ image: element.url });
      // console.log(element);
    });
    this.data.images.interior.forEach((element) => {
      images.push({ image: element.url });
      // console.log(element);
    });
    this.images = images;
    this.abolength = store.getters["reservation/GET_SELECTEDABO"];
  },
  methods: {
    openSearch() {
      this.$emit("openSearchTarif", this.car.id);
    },
    async lazyload() {
      this.images = this.car.images;
    },
    async getCars() {
      await store.dispatch("userSession/SET_VEHICLE", this.data);
      await store.dispatch("userSession/SET_STATION", this.data.location.id);
      store
        .dispatch("userSession/SET_CARGROUP", this.data.vehicle_group.id)
        .then(() => {
          store.dispatch("reservation/DELETE_TARIF");
          store.dispatch("stations/SET_OPENINGTIMES").then(() => {
            store
              .dispatch("reservation/CALCULATE_PRICE", {
                id: this.data.vehicle_group.id,
                extras: false,
                vehicle_id: this.data.id,
              })
              .then((tarif) => {
                // console.log(tarif);
                if (!tarif.main_rates) return;
                // console.log(tarif.main_rates.length);
                if (tarif.main_rates.length == 0) {
                  // const cartype = {};
                  // cartype[this.car["vehicle_category"][0]["id"]] = true;
                  // store.dispatch("userSession/SET_CARCATEGORY", cartype);
                  // if (process.env.VUE_APP_STANDALONE == "true") {
                  //   this.$router.push({ name: "Reservation_Step1" });
                  // } else {
                  //   window.location.href =
                  //     process.env.VUE_APP_BASE_URL +
                  //     process.env.VUE_APP_RESERVATION_PATH +
                  //     process.env.VUE_APP_RESERVATION_PATH_STEP1;
                  // }
                } else {
                  store.dispatch("reservation/SET_DRIVEDISTANCE", null);
                  store
                    .dispatch("reservation/SET_RESERVATION_TARIFS", tarif)
                    .then(() => {
                      routeToSteps(this, 2);
                    });
                }
              });
          });
        });

      //store.dispatch("userSession/SET_CARGROUP", this.car.id).then(() => {
      //  routeToSteps(this, 2);
      //});
    },
  },
});
</script>
